import 'react';
import 'styled-components';
import styledTheming from '../node_modules/styled-theming/index.js';
import '../App.css.js';
var borderCheck = styledTheming.variants("layout", "active", {
  false: {
    light: "border: 2px solid var(--light-gray-5);",
    dark: "border: 2px solid var(--dark-gray-5);"
  },
  true: {
    light: "border: 2px solid var(--green-300);",
    dark: "border: 2px solid var(--green-300);"
  }
});
var backgroundCheck = styledTheming.variants("layout", "active", {
  false: {
    light: "background-color: white;",
    dark: "background-color: white;"
  },
  true: {
    light: "background-color: var(--green-300);",
    dark: "background-color: var(--green-300);"
  }
});
export { backgroundCheck, borderCheck };